import { render, staticRenderFns } from "./ownerCars.vue?vue&type=template&id=194bfb65&scoped=true"
import script from "./ownerCars.vue?vue&type=script&lang=js"
export * from "./ownerCars.vue?vue&type=script&lang=js"
import style0 from "./ownerCars.vue?vue&type=style&index=0&id=194bfb65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194bfb65",
  null
  
)

export default component.exports